module.exports = __webpack_public_path__ + "img/precupetii-marker_en.b607c3db.png";